export default __webpack_public_path__ + "static/media/Pict.9a64663b.jpg";